// Reads the active quiz persona once, outside any React tree, so analytics
// payloads can attribute events to a persona without each emit callsite
// having to plumb it through. Returns null when the user hasn't completed
// enough of the quiz for the detector to make a confident call — in which
// case the persona prop is just omitted from the analytics payload.

import { useQuizStore } from '@/features/quiz';
import { detectPersona } from '@/features/recommender/persona';

export function currentPersona(): string | null {
  try {
    const answers = useQuizStore.getState().answers;
    if (Object.keys(answers).length === 0) return null;
    return detectPersona(answers);
  } catch {
    return null;
  }
}
